import { baseApi } from "api/BaseApi";

import { Note, NotePayload } from "./notes.types";

const NOTE_BASE_QUERY = "note";

const noteApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNotes: build.query<Note, string>({
      query: (noteId) => `${NOTE_BASE_QUERY}/${noteId}/`,
      providesTags: ["NOTE"],
    }),

    getNistNotes: build.query<Note[], string>({
      query: (nistId) =>
        `${NOTE_BASE_QUERY}/get_nist_notes_by_nist_id/?nist_id=${nistId}`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ note_id }) => ({
                type: "NOTE" as const,
                note_id,
              })),
              "NOTE",
            ]
          : ["NOTE"],
    }),

    getNotesByTypeAndTypeId: build.query<
      Note[],
      { noteType: string; noteTypeId: number; allowReplies: boolean }
    >({
      query: ({ noteType, noteTypeId, allowReplies }) => ({
        url: `${NOTE_BASE_QUERY}/get_notes_by_type_and_type_id`,
        params: {
          note_type: noteType,
          note_type_id: noteTypeId,
          allow_replies: allowReplies,
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ note_id }) => ({
                type: "NOTE" as const,
                note_id,
              })),
              "NOTE",
            ]
          : ["NOTE"],
    }),

    deleteNote: build.mutation<void, number>({
      query: (noteId) => ({
        url: `${NOTE_BASE_QUERY}/${noteId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["NOTE"],
    }),

    // TODO: Talk about partial note
    updateNote: build.mutation<Note, { noteId: number; body: Partial<Note> }>({
      query: ({ noteId, body }) => ({
        url: `${NOTE_BASE_QUERY}/${noteId}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["NOTE"],
    }),

    addNote: build.mutation<Note, NotePayload>({
      query: (body) => ({
        url: `${NOTE_BASE_QUERY}/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["NOTE"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetNotesQuery,
  useGetNistNotesQuery,
  useGetNotesByTypeAndTypeIdQuery,
  useDeleteNoteMutation,
  useUpdateNoteMutation,
  useAddNoteMutation,
} = noteApi;
